import { formatInTimeZone } from 'date-fns-tz';
import { toNumber } from 'src/utils/numberFormatters';
import { timezone } from 'src/utils/dateUtils';

interface ServiceWithFuturePrice {
  price?: number | string | null;
  future_price?: number | string | null;
  future_price_valid_from?: string | null;
}

/**
 * Price of the service effective on the given date (today when omitted).
 * Mirrors BE Service.get_price_for_date.
 */
export function getServicePriceForDate(
  service: ServiceWithFuturePrice | null | undefined,
  date?: string | Date | null
): number {
  const price = toNumber(service?.price) ?? 0;
  const futurePrice = toNumber(service?.future_price);
  if (futurePrice === undefined || !service?.future_price_valid_from) {
    return price;
  }

  const day = formatInTimeZone(date ?? new Date(), timezone, 'yyyy-MM-dd');
  return day >= service.future_price_valid_from ? futurePrice : price;
}
